import { Component, OnInit } from '@angular/core';
import {ReceivablesBalanceService} from "../../services/receivables-balance.service";
import {MatDialogRef} from "@angular/material/dialog";
import {take} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-receivables-balance-restart-all-dialog',
  templateUrl: './receivables-balance-restart-all-dialog.component.html',
  styleUrls: ['./receivables-balance-restart-all-dialog.component.scss']
})
export class ReceivablesBalanceRestartAllDialogComponent implements OnInit {
  status: 'loading' | 'accepted' | 'error' = 'loading';
  errorMessage = '';

  constructor(
    public dialogRef: MatDialogRef<ReceivablesBalanceRestartAllDialogComponent>,
    private receivablesBalanceService: ReceivablesBalanceService
  ) {}

  ngOnInit(): void {
    this.receivablesBalanceService.restartAll()
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.status = 'accepted';
          this.dialogRef.disableClose = false;
        },
        error: (error: HttpErrorResponse) => {
          this.status = 'error';
          this.errorMessage = error.status === 0
            ? 'Nie można połączyć się z serwerem.'
            : `Nie udało się uruchomić odświeżania sald (HTTP ${error.status}).`;
          this.dialogRef.disableClose = false;
        }
      });
  }

  close(): void {
    this.dialogRef.close(this.status === 'accepted');
  }
}
